var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { FUNCIONALIDADES, PAGINAS, ROUTES } from '../../../routes';
import { MENSAGENS } from '../../../utils';
import { useAuth } from '../../../contexts/auth/AuthContext';
import StatusPesquisar from '../../../components/status_pesquisar';
import { FinanceiroListarBase } from '../components/FinanceiroListarBase';
import { alterarSituacaoParametrosFolha, getParametrosFolhas } from './parametros_folhas.service';
export var ParametrosParametrosFolhasListar = function () {
    var _a = useState('-1'), buscaSituacaoSelecionada = _a[0], setBuscaSituacaoSelecionada = _a[1];
    var _b = useState(0), recarregarTrigger = _b[0], setRecarregarTrigger = _b[1];
    var getAcoesFuncionalidade = useAuth().getAcoesFuncionalidade;
    var acoesFuncionalidade = getAcoesFuncionalidade(FUNCIONALIDADES.PARAMETROS_FOLHAS);
    var alterarStatusParametros = function (id, situacao) { return __awaiter(void 0, void 0, void 0, function () {
        var resp;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, alterarSituacaoParametrosFolha(id.toString(), situacao)];
                case 1:
                    resp = _a.sent();
                    if ((resp === null || resp === void 0 ? void 0 : resp.Status) === 'OK') {
                        alert(situacao === 'ATIVO' ? MENSAGENS.REGISTRO_ATIVADO : MENSAGENS.REGISTRO_INATIVADO);
                        setRecarregarTrigger(function (prev) { return prev + 1; });
                    }
                    else if (resp) {
                        alert(resp.Mensagem);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var inativarParametrosOpcao = function (params) {
        var _a = params.row, id = _a.id, parametros_em_uso = _a.parametros_em_uso, situacao = _a.situacao;
        if (!(acoesFuncionalidade === null || acoesFuncionalidade === void 0 ? void 0 : acoesFuncionalidade['ALTERAR']))
            return null;
        return situacao === 'Ativo' ? (_jsx(Tooltip, __assign({ title: parametros_em_uso ? 'Não é possível desativar. Parâmetros em uso' : 'Inativar parâmetros', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 1, paddingRight: 0, marginTop: -1 }, onClick: function () {
                    if (parametros_em_uso) {
                        alert('73 – Não é possível inativar um parâmetro com folhas abertas.');
                        return;
                    }
                    if (confirm('Tem certeza que deseja INATIVAR o registro selecionado?')) {
                        alterarStatusParametros(id, 'Inativo');
                    }
                } }, { children: _jsx(CancelIcon, { sx: { fontSize: 30 } }) })) }))) : (_jsx(Tooltip, __assign({ title: 'Ativar parâmetros', componentsProps: { tooltip: { sx: { fontSize: '0.9rem' } } } }, { children: _jsx(IconButton, __assign({ style: { padding: 0, margin: 1, paddingRight: 0, marginTop: -1 }, onClick: function () {
                    if (confirm('Tem certeza que deseja ATIVAR o registro selecionado?')) {
                        alterarStatusParametros(id, 'Ativo');
                    }
                } }, { children: _jsx(CancelIcon, { sx: { fontSize: 30 } }) })) })));
    };
    var services = {
        getDados: function (textoBusca, _, paginationModel) {
            return getParametrosFolhas(textoBusca, buscaSituacaoSelecionada === '-1' ? null : buscaSituacaoSelecionada, paginationModel);
        },
    };
    var COLUNAS_FUNCIONALIDADE = [
        { field: 'id', headerName: 'Código', width: 100 },
        { field: 'nome', headerName: 'Nome', width: 300 },
        { field: 'ano_referencia', headerName: 'Ano', width: 150 },
        { field: 'situacao', headerName: 'Situação', width: 150 },
    ];
    return (_jsx(FinanceiroListarBase, { pagina: PAGINAS.PARAMETROS_FOLHAS, paginaEspecificaPermissao: FUNCIONALIDADES.PARAMETROS_FOLHAS, rota: ROUTES.PARAMETROS_FOLHAS, colunas: COLUNAS_FUNCIONALIDADE, services: services, opcaoAdicional: inativarParametrosOpcao, filtrosJSX: _jsx(StatusPesquisar, { StatusPesquisa: buscaSituacaoSelecionada, setStatusPesquisa: setBuscaSituacaoSelecionada }) }, recarregarTrigger));
};
export default ParametrosParametrosFolhasListar;
